export type PlatformKind = 'storage' | 'membership' | 'addon' | 'credits' | 'emails' | 'other'

export type PlatformMeta = {
  enabled: boolean
  kind?: PlatformKind
  plan_key?: string
  pack_key?: string
  tier_key?: string
}

export function buildPurchaseContext({
  product,
  activeRecurring,
  selectedRecurringId,
  price,
  priceUSD,
  quantity = 1,
  unitPrice,
  unitPriceUSD,
  tracking,
  paymentMethods = [],
  platform,
}: {
  product: any
  activeRecurring: any | null
  selectedRecurringId: number | null
  price: number
  priceUSD: number
  quantity?: number
  unitPrice?: number
  unitPriceUSD?: number
  tracking?: string | null
  paymentMethods?: any[];
  platform?: PlatformMeta
}) {
  const recurrings = product.recurrings ?? []

  const hasRecurring = recurrings.length > 0

  const safeQuantity = hasRecurring
    ? 1
    : Math.max(1, Math.min(99, Math.floor(Number(quantity || 1))))

  const safeUnitPrice = Number.isFinite(Number(unitPrice))
    ? Number(unitPrice)
    : Number(price || 0)

  const safeUnitPriceUSD = Number.isFinite(Number(unitPriceUSD))
    ? Number(unitPriceUSD)
    : Number(priceUSD || 0)
    
  return {
    product,
    productId: product.product_id,
    productName: product.name,

    // ✅ seller efectivo de la venta
    sellerId: product.seller_id,

    // ✅ dueño real/original del producto
    ownerSellerId: product.owner_seller_id || product.seller_id,

    partnerId: product.partner_id || product.seller_id,
    invite: product.invite || null,
    thankyou: product.thankyou || null,
    recurrings,
    activeRecurring,
    selectedRecurringId,

    recurringId: selectedRecurringId,
    recurringPlan: activeRecurring || null,

    price,
    priceUSD,
    amount: price,
    amountUSD: priceUSD,

    quantity: safeQuantity,
    unitPrice: safeUnitPrice,
    unitPriceUSD: safeUnitPriceUSD,
    totalPrice: price,
    totalPriceUSD: priceUSD,

    currency: product.currency || 'USD',

    markup: product.markup || 0,
    markupUSD: product.markup_base || 0,
    platformFee: product.platform_fee || 0,
    trackingCode: tracking || product.tracking || null,

    whitelabel: !!product.whitelabel,
    approveId: product.approve_id || 0,

    paymentMethods: product.paymentMethods,
    platform,
    signup: {
      enabled: true,
      mode: 'express',
      action: 'product',
    } as const,
  }
}